<template>
  <div class="map">
    <el-row style="display: flex; justify-content: center;">
      <el-col>
        <div class="GmapMapBox">
          <GmapMap @click="clickMap" :center="center" :zoom="zoom" style="width: 100%; height: 500px">
            <GmapMarker :key="index" v-for="(m, index) in markers" :position="m.position" @click="clickMarker(m.position)" />
          </GmapMap>
        </div>
        <el-row style="" class="btn-box">
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "GoogleMap",
  data() {
    return {
      center: { lat: 10.0, lng: 10.0 }, // 中心位置
      center_: { lat: 10.0, lng: 10.0 }, // 保存当前点位置
      currentPlace: null,
      markers: [],
      places: [],
      placeName: "",
      dialogVisible: true,
      googlemap: "",
      hasSetPin: false,
      zoom: 12,
      // address: "",
      addressInput:"",
    };
  },
  watch: {
    address: function(newVal, oldVal) {
      // 当 `address` 的值改变时，调用 `getGeocoderFromAddress` 方法来更新地图的显示
      if (newVal !== oldVal) {
        console.log(newVal)
        this.getGeocoderFromAddress(newVal);
      }
    }
  },
  props: ['gpsName','address'],
  mounted() {
    if (this.gpsName != 'Positioning') {
      let gpsArr = this.gpsName.split(',')
      if (gpsArr && gpsArr.length > 0) {
        this.zoom = 15
        this.center.lat = gpsArr[0] * 1
        this.center.lng = gpsArr[1] * 1
        this.center_.lat = gpsArr[0] * 1
        this.center_.lng = gpsArr[1] * 1
        this.markers.push({ position: this.center_ });
      }
      this.hasSetPin = true
    } else {
      this.geolocate();
    }
  },
  methods: {
    getGeocoderFromAddress(address) {
      let self = this
      // 创建地理编码服务实例
      this.$gmapApiPromiseLazy().then(() => {
        const geocoder = new google.maps.Geocoder();
        geocoder.geocode({ 'address': address }, function (results, status)  {
          console.log('google-map-1',results);
          console.log('google-map-2',status)
          if (status === 'OK') {
            if (results[0]) {
              var location = results[0].geometry.location;
              self.center_ = {
                lat: location.lat(),
                lng: location.lng(),
              };
              console.log('self.center_',self.center_);
              self.markers = [];
              self.markers.push({ position: self.center_ });
              self.$emit("setMap", {
                lat:location.lat(),
                lng:location.lng(),
              });
              self.center = self.center_;
            } else {
              console.log('未找到地址信息');
            }
          } else {
            console.log('地理编码服务请求失败');
          }
        });
      })

    },
    setPlace(place) {
      console.log("setPlace", place)
      this.currentPlace = place;
      let address = place.formatted_address;
      console.log('address',address)
      this.$emit("setMap", {
        lat:place.geometry.location.lat(),
        lng:place.geometry.location.lng(),
        address:this.addressInput
      });
      this.addMarkerFun();
    },
    addMarkerFun() {
      if (this.currentPlace) {
        this.hasSetPin = true
        this.zoom = 15
        const marker = {
          lat: this.currentPlace.geometry.location.lat(),
          lng: this.currentPlace.geometry.location.lng(),
        };
        this.markers = [];
        this.markers.push({ position: marker });
        this.places.push(this.currentPlace);
        this.center = marker;
        this.center_ = marker;
        this.placeName = this.currentPlace.name;
        // this.currentPlace = null;
      }
    },
    geolocate: function () {
      let vm = this
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
          if (position && position.coords && position.coords.latitude) {
            // alert("获取地理位置："+position.coords.latitude+","+position.coords.longitude)
            vm.hasSetPin = true
            vm.zoom = 10
            vm.center = {
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            };
            vm.center_ = vm.center
            vm.markers.push({ position: vm.center });
          }
        }, (error) => {  // html5 默认调用的谷歌的接口，会有安全限制
          switch (error.code) {
            case error.PERMISSION_DENIED: // 许可拒绝,用户选了不允许
              break;
            case error.POSITION_UNAVAILABLE: // 连不上GPS卫星，或者网络断了
              break;
            case error.TIMEOUT:  // /超时了
              break;
            case error.UNKNOWN_ERROR:
              break;
          }
        });
      } else {
      }
    },
    clickMap(e) {
      console.log("clickmap", e)
      this.hasSetPin = true
      let longlat = e.latLng.lat() + "," + e.latLng.lng();
      this.center_ = {
        lat: e.latLng.lat(),
        lng: e.latLng.lng(),
      };
      this.markers = [];
      this.markers.push({ position: this.center_ });
      this.getGeocoder(this.center_)


    },
    clickMarker(val) {
      console.log("clickMarker", val)
      this.center = val;
      this.center_ = val;
      this.getGeocoder(this.center_)
    },
    submitMap() {
      if (!this.hasSetPin) {
        return
      }
      let obj = Object.assign({}, this.center_);
      obj.name = `${this.center_.lat.toFixed(5)},${this.center_.lng.toFixed(5)}`;
      obj.placeName = this.placeName;
      this.$emit("setMap", obj);
    },
    cancelMap() {
      this.$emit("closeMap");
    },

    getGeocoder(latlng) {
      let self = this
      // 创建地理编码服务实例
      var geocoder = new google.maps.Geocoder();
      // 调用地理编码服务的方法
      geocoder.geocode({ 'location': latlng }, function (results, status) {
        if (status === 'OK') {
          console.log('results', results);
          if (results[0]) {
            var formattedAddress = results[0].formatted_address;
            let obj = Object.assign({}, self.center_);
            obj.name = `${self.center_.lat.toFixed(5)},${self.center_.lng.toFixed(5)}`;
            obj.address = formattedAddress;
            self.$emit("setMap", obj);
          } else {
            console.log('未找到地址信息');
          }
        } else {
          console.log('地理编码服务请求失败');
        }
      });
    },
  },
};
</script>
<style scoped>
.add-btn {
  width: 60px;
  margin-left: 2%;
  height: 40px;
  background: #409eff;
  color: #fff;
  border: 0;
  border-radius: 5px;
}

.search-box input {
  height: 40px;
  width: 50%;
  border-radius: 5px;
  border: 1px solid #ccc;
  padding-left: 7px;
  outline: none;
}

/* 底部两个按钮 */
.btn-box {
  margin-top: 16px;
}

.btn-box .el-button {
  padding: 8px 30px;
  border-radius: 30px;
  width: 140px;
  height: 40px;
}

.confirm {
  color: #fff;
  background-color: #0778bc;
}

.cancel {
  color: #0778bc;
  border: 1px solid #0778bc;
}

.cursor {
  cursor: pointer;
}

.map .GmapMapBox {
  /* background-image: url(../assets/img/loading.gif); */
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 24px 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/map/GoogleMap.vue